import { render, staticRenderFns } from "./DialogNewComplaintForm.vue?vue&type=template&id=779e501e&scoped=true&"
import script from "./DialogNewComplaintForm.vue?vue&type=script&lang=js&"
export * from "./DialogNewComplaintForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779e501e",
  null
  
)

export default component.exports